import React, { useEffect } from "react";
import "./works.css";
import topBanner from "assets/works/works-top.png";
import Meta from "utils/meta";
import WorksData from "utils/worksData";
import SingleWorkBlock from "./SingleWorkBlock";

const Works = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Wroks | The Realtor Desk" description="" />
      <div className="works-outer-container">
        <div className="works-banner">
          <div className="container">
            <div className="works-banner--content">
              <h1>Real Estate CRM and Marketing Software</h1>
              <h4>Pay only for what you use</h4>
              <p>Real Estate Software for individual and enterprise level realtors which will help you to provide real estate services in more efficiently and effectively than ever before.</p>
            </div>
            <div className="works-banner--image">
              <img src={topBanner} alt="Modern-Day Products Built To Empower Your Real Estate Business" />
            </div>
          </div>
        </div>
        <div className="container">
          {WorksData.map((item, index) => (
              <SingleWorkBlock
                key={index}
                title={item.title}
                subtitle={item.subtitle}
                isImage={item.isImage}
                image={item.image}
                imagePosition={item.imagePosition}
                coloredBG={item.coloredBG}
                leftIconWithText={item.leftIconWithText}
                rightIconWithText={item.rightIconWithText}
              />
          ))}
        </div>
      </div>
    </>
  );
};

export default Works;
